import { Container, Typography, Box, Divider } from '@mui/material';

const RefundCancellationPolicy = () => {
  return (
    <Container
      maxWidth='md'
      sx={{
        lineHeight: 1.3,
      }}
    >
      {/* Header */}
      <Typography
        variant='h4'
        gutterBottom
        sx={{
          fontWeight: 'bold',
          color: '#181436',
          fontSize: { xs: '1.8rem', md: '2.5rem' },
        }}
      >
        Refund & Cancellation Policy
      </Typography>
      <Typography variant='body2' color='text.secondary' gutterBottom>
        Effective Date: August 2, 2025
      </Typography>

      <Divider sx={{ my: { xs: 2, md: 3 } }} />

      {/* Sections */}
      <Box sx={{ mt: 2 }}>
        {[
          {
            title: '1. Order Cancellations',
            content:
              'You may cancel your order through the SingleCombo app or website before the restaurant or merchant begins preparing your order. Once preparation has started, the order cannot be canceled. If you attempt to cancel after preparation begins, charges may still apply.',
          },
          {
            title: '2. Refund Eligibility',
            content:
              'Refunds are generally not available once an order is confirmed and delivered. However, we may provide refunds or credits at our discretion in cases of missing items, incorrect orders, or significant delays.',
          },
          {
            title: '3. Non-Refundable Items',
            content:
              'Delivery fees, service fees, and small order fees are non-refundable. Membership or subscription fees are also non-refundable except where required by law.',
          },
          {
            title: '4. Refund Process',
            content:
              'If eligible for a refund, it will typically be issued as a credit to your SingleCombo account within 2–5 business days. In some cases, we may issue a refund to your original payment method.',
          },
          {
            title: '5. Abuse of Refunds',
            content:
              'Repeated or fraudulent refund claims may result in suspension or permanent deactivation of your account.',
          },
          {
            title: '6. Contact for Refunds',
            content:
              'To request a refund or report an issue with your order, please contact our support team within 24 hours of receiving your order.',
          },
          {
            title: '7. Meal Plan Memberships',
            content:
              'Meal plan memberships automatically renew until canceled. You may cancel at least one (1) day before your next billing cycle to avoid charges. Membership fees are non-refundable except where required by law.',
          },
          {
            title: '8. Contact Us',
            content:
              'SingleCombo Support Team\nEmail: info@singlecombo.com\n\nAddress: 4556 Oakton, Skokie, IL 60077',
          },
        ].map((section, index) => (
          <Box key={index} sx={{ mb: { xs: 3, md: 4 } }}>
            <Typography
              variant='h6'
              gutterBottom
              sx={{
                fontWeight: 600,
                fontSize: { xs: '1rem', md: '1.2rem' },
              }}
            >
              {section.title}
            </Typography>
            <Typography paragraph sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
              {section.content}
            </Typography>
          </Box>
        ))}
      </Box>
      <div style={{ height: '100px', color: 'white' }}>Empty space for mobile</div>
    </Container>
  );
};

export default RefundCancellationPolicy;
